import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import BusinessNameGeneratorSessionID from '@/FreeTool/BusinessNameGenerator/Entity/BusinessNameGeneratorSessionID'
import type {
    BusinessNameGeneratorSessionRawData,
    GeneratedBusinessName,
    GeneratedService,
} from '@/Shared/AutoGenerated/Main'

export default class BusinessNameGeneratorSession {
    constructor(
        public readonly id: BusinessNameGeneratorSessionID,
        public readonly step: string,
        public readonly userPrompt: string,
        public readonly generatedBusinessNames: GeneratedBusinessName[],
        public readonly generatedService: GeneratedService | null,
        public readonly selectedBusinessNameId: string | null,
    ) {
        ensureNoUndefinedProperties(this)
    }

    hasGeneratedBusinessName(): boolean {
        return this.generatedBusinessNames.length > 0
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingleOrNull(
        entityData: BusinessNameGeneratorSessionRawData | null,
    ): BusinessNameGeneratorSession | null {
        if (!entityData) {
            return null
        }

        return this.hydrateSingle(entityData)
    }

    static hydrateSingle(
        entityData: BusinessNameGeneratorSessionRawData,
    ): BusinessNameGeneratorSession {
        return new BusinessNameGeneratorSession(
            new BusinessNameGeneratorSessionID(entityData.id),
            entityData.step,
            entityData.userPrompt,
            entityData.generatedBusinessNames,
            entityData.generatedService,
            entityData.selectedBusinessNameId,
        )
    }
}
